import { render, staticRenderFns } from "./couponCodeList.vue?vue&type=template&id=56742a89&scoped=true&"
import script from "./couponCodeList.vue?vue&type=script&lang=js&"
export * from "./couponCodeList.vue?vue&type=script&lang=js&"
import style0 from "./couponCodeList.vue?vue&type=style&index=0&id=56742a89&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56742a89",
  null
  
)

export default component.exports